/* globals YT */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.fancyboxInit = (function () {
    // console.log('fancyboxInit()')
    const initialize = function () {
      $('.js-fancybox-design-gallery').fancybox({
        wrapCSS: 'design-gallery__modal',
        helpers: {
          title: {
            type: 'outside',
            position: 'bottom'
          }
        },
        afterLoad: function (current, previous) {
          const $this = $(current.element)
          // find the HTML for the overlay content
          const $parent = $this.parents('.basicImage')
          const $infoPanel = $parent.find('.infoPanel')

          current.title = $infoPanel.html()

          // we need to re-parse the Pinterest link
          setTimeout(function () {
            const $pinterest = $('.fancybox-title').find('.linksWrap a').not('.download')
            if (typeof window.parsePinBtns === 'function') {
              window.parsePinBtns($pinterest[ 0 ]) // now have pinterest reload the buttons
            }
          }, 200)
        }
      })

      $('.js-fancybox-inspiration').fancybox({
        afterLoad: function (current, previous) {
          const $this = $(current.element)
          // find the HTML for the overlay content
          const $parent = $this.parents('.basicImage')
          const $infoPanel = $parent.find('.infoPanel')

          current.title = $infoPanel.html()

          // we need to re-parse the Pinterest link
          setTimeout(function () {
            const $pinterest = $('.fancybox-title').find('.linksWrap a').not('.download')
            if (typeof window.parsePinBtns === 'function') {
              window.parsePinBtns($pinterest[ 0 ]) // now have pinterest reload the buttons
            }
          }, 200)
        }
      })

      if ($('.js-fancybox-referral').length) {
        $('.js-fancybox-referral').fancybox({
          type: 'inline',
          content: '<p>Did too.</p>',
          beforeShow: function () {
            const $inner = $('.fancybox-inner')
            $inner.empty()
            $('.referral-modal-content').appendTo($inner)
          },
          autoSize: true // This is being used strictly for videos so enforce a viewing size
        })

        const formId = 'form#' + $('.referral-modal-content form').attr('id') + '.ninja-forms-form'

        console.log('removing ninja submitResponse handler for ', formId)

        $(formId).off('submitResponse')
        $(document).off('submitResponse.default')
        $('body').off('submitResponse.default')

        let queryString = ''

        const alterMIRHLink = function (e, response) {
          const $mirhLink = $('.mirh-link')
          if ((response.errors === false) && $mirhLink.length && ($mirhLink.attr('href').indexOf('?') === -1)) {
            const hrefMIRH = $mirhLink.attr('href')
            // console.log("I found the link", hrefMIRH, "and the querystring is",queryString);
            $mirhLink.attr('href', hrefMIRH + queryString)
            // $('.mirh-link').text('I\'M DIFFERENT');
            $.fancybox.update()
          } else {
            // console.log('MIRH Link hadn\'t rendered yet...');
          }
          // alert("alertMIRHLink ends: " + $('.mirh-link').attr('href'));
        }

        $(formId).on('beforeSubmit.adjustLink', function (e, response) {
          const locationList = window.locationList || JSON.parse($('#locations-json').text())
          let queryStringVars = []

          // Pull the ID's of the selected options and concatenate them into a querystring.
          $('select.newhome option').filter(':selected').each(function () {
            queryStringVars.push('location_list%5B%5D=' + locationList[ $(this).val() ])
          })

          queryString = '?' + queryStringVars.join('&')
          // alert('parseNewHomes ends ' + queryString);

          $(this).on('submitResponse.doTheThing', alterMIRHLink)
        })
      }

      $('.js-fancybox').each(function (i, el) {
        // console.log('fancyboxInit js-fancybox setup()')

        const $el = $(el)
        $el.fancybox({
          type: 'iframe',
          href: $el.attr('href'),
          autoSize: false, // This is being used strictly for videos so enforce a viewing size
          height: '600'
        })

        // $el.find('span.play-button').append('<span class="the-play-button">');
      })

      // $('.js-fancybox-inline').on('click', (e) => e.preventDefault())
      $('.js-fancybox-inline').each(function (i, el) {
        const vpW = $(window).width()
        // console.log('vpW', vpW)
        const $el = $(el)
        $el.fancybox({
          type: 'inline',
          padding: 10,
          margin: vpW < 700 ? 25 : 50,
          maxWidth: 700,
          // width: 600,
          // width: vpW < 700 ? '90%' : 600,
          height: 'auto',
          autoScale: true,
          // autoSize: true,
          // autoDimensions: true,
          hideOnContentClick: false
        })

        // $el.find('span.play-button').append('<span class="the-play-button">');
      })

      const youtubeVideos = $('.fancybox-youtube')
      if (youtubeVideos) {
        // console.log('adding YT code');
        let tag = document.createElement('script')

        tag.src = 'https://www.youtube.com/iframe_api'
        let firstScriptTag = document.getElementsByTagName('script')[ 0 ]
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

        let player = null // eslint-disable-line no-unused-vars

        window.onPlayerReady = function (event) {
          // console.log('YT playing....', event);
          event.target.playVideo()
        }

        let done = false
        window.onPlayerStateChange = function (event) {
          // console.log('YT state change', event);

          if (event.data === YT.PlayerState.PLAYING && !done) {
            // setTimeout(stopVideo, 6000)
            done = true
          }
        }

        window.onYouTubeIframeAPIReady = function () {
          // console.log('YT ready');
          player = new YT.Player('player', {
            height: '315',
            width: '560',
            videoId: 'l-gQLqv9f4o',
            events: {
              'onStateChange': window.onPlayerStateChange
            }
          })
        }
      }

      $('.js-fancybox-lotGallery').fancybox({})

      $('.js-fancybox-bio').fancybox({
        // tell it to show inline content rather than image
        type: 'inline'
      })

      $('.js-fancybox-floorplan').fancybox({
        // tell it to show inline content rather than image
        type: 'inline'
      })

      // For Careers page, open up jobs link in iframe via fancybox
      /* $("#jobSearchLink.external").fancybox({
       'width':            '75%',
       'height':           '65%',
       'autoScale':        false,
       'transitionIn':     'elastic',
       'transitionOut':    'none',
       'type':             'iframe',
       }); */

      const autoplay = eah.common.urlParams[ 'autoplay' ]
      const autoplayEls = $('[data-autoplay]')
      if (autoplay && autoplayEls) {
        const playIt = $('[data-autoplay="' + autoplay + '"]')
        if (playIt) {
          $(playIt).trigger('click')
        }
        // autoplayEls.each(function (index, el) {
        //   var i = index + 1;
        //   if (i == autoplay) {
        //     $(el).trigger('click');
        //   }
        // });
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    setTimeout(eah.fancyboxInit.initialize, 250)
  })
}(jQuery, window))
